export default __webpack_public_path__ + "static/media/check-green.caa4b4b3.svg";